import { render, staticRenderFns } from "./FeatureView.vue?vue&type=template&id=b469ccde&scoped=true&"
import script from "./FeatureView.vue?vue&type=script&lang=ts&"
export * from "./FeatureView.vue?vue&type=script&lang=ts&"
import style0 from "./FeatureView.vue?vue&type=style&index=0&id=b469ccde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b469ccde",
  null
  
)

export default component.exports